import tree from './tree.vue'
tree.install = function (Vue) {
  Vue.component(tree.name, tree);
};
export default tree



// WEBPACK FOOTER //
// ./src/omnis-business/db-soft-tree/index.js